export var ValueEvent;
(function (ValueEvent) {
    ValueEvent["Yes"] = "Y";
})(ValueEvent || (ValueEvent = {}));
//# sourceMappingURL=ValueEvent.js.map